import React from 'react'
import { Prompt } from 'react-router-dom'
import { range } from 'lodash'
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  Button,
  CircularProgress,
  Input,
  Grid,
  TablePagination
} from '@material-ui/core/index'
import { Toast } from 'devextreme-react/toast'
import { Add, Save } from '@material-ui/icons'
import actions from '../reducers/actions'
import { connect } from 'react-redux'
import CellComponent from '../components/CellComponent'
import InvoiceModal from '../components/modals/Invoice'
import LongNoteModal from '../components/modals/LongNote'
import Navigation from '../components/Navigation'
import RouteChickenModal from '../components/RouteChickenModal'
import SearchSelect from '../components/SearchSelect'
import VendorChangeModal from '../components/VendorChangeModal'
import { shouldValidate, isValidInput, validationFields, getTitle, parseQuery, getHoursDiff } from '../utils'
import { OFFICE_USER } from '../constants/permissions'
import { sqlUnsafe } from '../utils/sqlSafe'
import { emailInvoice } from '../service/client'
import generateTimesheetsPdf from '../utils/generateTimesheetsPdf'
import moment from 'moment'

class TimeSheet extends React.Component {
  constructor(props) {
    super(props)
    document.title = getTitle()

    this.setRows = this.setRows.bind(this)
    this.enterPressed = this.enterPressed.bind(this)
    this.renderHeaderLabels = this.renderHeaderLabels.bind(this)
    this.renderTableRow = this.renderTableRow.bind(this)
    this.renderTableCells = this.renderTableCells.bind(this)
    this.updateRowAndErrors = this.updateRowAndErrors.bind(this)
    this.clearRow = this.clearRow.bind(this)
    this.onRouteBlur = this.onRouteBlur.bind(this)
    this.setVendorOverride = this.setVendorOverride.bind(this)
    this.validateForm = this.validateForm.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.recurseParentElements = this.recurseParentElements.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
    this.onAddPage = this.onAddPage.bind(this)
    this.onSave = this.onSave.bind(this)
    this.renderVendorSelector = this.renderVendorSelector.bind(this)
    this.onVendorChange = this.onVendorChange.bind(this)
    this.filterVendors = this.filterVendors.bind(this)

    const rows = [...Array(18)].map(() => ({}))

    this.state = {
      rows,
      submitting: false,
      showSnackbar: false,
      snackbarSeverity: 'error',
      errors: [],
      fetching: true,
      saving: false,
      userVendorID: null,
      showVendorChangeModal: false,
      showModal: false,
      modalProperty: null,
      routeVendor: null,
      routeExtraData: null,
      page: 0,
      modalRowIdx: 0,
      changesSaved: true,
      selectedVendor: {},
      readOnly: false,
      deletedJobIDs: []
    }
    this.isAdmin = this.props.user.username.toLowerCase() === 'admin'
    this.vendorOptions = []
    this.submitted = this.props.data.savedTimeSheets.filter(t => t.TimeSheetID === this.props.data.selectedTimeSheetId)[0]?.Submitted
    this.canDelete = this.props.user.username.toLowerCase() === 'admin' || !this.props.data.savedTimeSheets.filter(t => t.TimeSheetID === this.props.data.selectedTimeSheetId)[0]?.Submitted
    this.columns = [
      {
        label: '',
        field: 'rowNum'
      },
      {
        label: 'Route ID',
        field: 'routeId'
      },
      {
        label: 'Property Name',
        field: 'propNameAddress'
      },
      {
        label: 'Address',
        field: 'address'
      },
      {
        label: 'Date of Service Start',
        field: 'dateTimeStart'
      },
      {
        label: 'Date of Service End',
        field: 'dateTimeEnd'
      },
      {
        label: '% Service Complete',
        field: 'crewPercent'
      },
      {
        label: 'P, S, CW, DIW',
        field: 'code'
      },
      {
        label: '# Bags or Tons',
        field: 'quantityMaterial'
      },
      {
        label: '# Plows or Techs',
        field: 'plowsOrTechs'
      },
      {
        label: 'Total Man Hours',
        field: 'totalHours'
      },
      {
        label: 'Snow Depth',
        field: 'snowDepth'
      },
      {
        label: 'Notes',
        field: 'notes'
      },
      {
        label: '',
        field: 'clearRow'
      }
    ]
  }

  setRows({ Rows, Submitted }) {
    const { data: { routeInfo } } = this.props
    const oldRows = this.state.rows.slice()
    let newRows = this.getEmptyRows(range(0, 18), oldRows)
    Rows?.forEach(({
      Jobs_ID,
      RowIdx,
      RouteID,
      DateTimeStart,
      DateTimeEnd,
      CrewPercent,
      QuantityMaterial,
      PlowsOrTechs,
      SnowDepth,
      Notes,
      VendorOverride,
      CrewOverride
    }) => {
      if (!oldRows[RowIdx]) {
        newRows = this.getEmptyRows(range(newRows.length, RowIdx), newRows)
      }

      const foundRouteInfo = routeInfo.find(({ PropAgr_ID }) => PropAgr_ID === RouteID)
      const newRow = {}
      newRow.Jobs_ID = Jobs_ID
      newRow.routeId = RouteID
      newRow.extraData = foundRouteInfo
      newRow.propNameAddress = foundRouteInfo && foundRouteInfo.PropName
      newRow.address = foundRouteInfo && foundRouteInfo.Address
      newRow.street = foundRouteInfo && foundRouteInfo.Address && foundRouteInfo.Address.split('  ')[0]
      newRow.vendorOverride = VendorOverride || void 0
      newRow.crewOverride = CrewOverride || void 0
      newRow.dateTimeStart = DateTimeStart || null
      newRow.dateTimeEnd = DateTimeEnd || null
      newRow.crewPercent = CrewPercent || ''
      newRow.quantityMaterial = QuantityMaterial || ''
      newRow.plowsOrTechs = PlowsOrTechs || ''
      newRow.snowDepth = SnowDepth || ''
      newRow.notes = Notes || ''
      newRows[RowIdx] = newRow
    })
    const intToParse = (newRows.length - 1) / 18 + 1
    const numPagesThatThereShouldBe = parseInt(intToParse)
    const totalRowLength = 18 * numPagesThatThereShouldBe
    if (newRows.length < totalRowLength) {
      newRows = this.getEmptyRows(range(newRows.length, totalRowLength), newRows)
    }

    this.setState({ rows: newRows })
  }

  UNSAFE_componentWillMount() {
    document.addEventListener('keydown', this.enterPressed, false)

    const {
      user,
      data: { routeInfo, selectedTimeSheetId, savedTimeSheets },
      getRouteInfo,
      getCrews,
      getUserInfo,
      getSavedTimeSheetById,
      setSelectedTimeSheet,
      getVendors
    } = this.props

    const { crews, crewIdd, permissions, vendors } = user

    this.checkQueryParams(selectedTimeSheetId, setSelectedTimeSheet)

    const promises = []
    if (!routeInfo.length) promises.push(getRouteInfo(user))
    if (!crews.length) promises.push(getCrews(user))
    if (!vendors.length) promises.push(getVendors(user))

    const queryParams = History.location.search
    const timeSheetId = queryParams.length ? parseInt(parseQuery(queryParams).id) || null : null

    if (!permissions.length && !crewIdd && timeSheetId) {
      const promise = getUserInfo(user).then(() => getSavedTimeSheetById(this.props.user, timeSheetId))
      promises.push(promise)
    } else if (!savedTimeSheets.length && timeSheetId) {
      promises.push(getSavedTimeSheetById(this.props.user, timeSheetId))
    }

    Promise.all(promises)
      .then((r) => {
        const foundTimeSheet = this.props.data.savedTimeSheets.find(({ TimeSheetID }) => this.props.data.selectedTimeSheetId === TimeSheetID)
        if (foundTimeSheet) this.setRows(foundTimeSheet)

        const { user: { vendorIdd, vendors: newVendors } } = this.props
        this.vendorOptions = newVendors.map(({ VendorID, VendorName }) => ({ label: `${VendorName}`, value: VendorID }))

        const selectedVendor = this.getSelectedVendor(vendorIdd, newVendors, foundTimeSheet)
        const disableSubmit = !foundTimeSheet?.invoice_status ? false : foundTimeSheet.invoice_status > 0

        this.setState({
          selectedVendor,
          shortNote: foundTimeSheet?.ShortNote != undefined ? sqlUnsafe(foundTimeSheet.ShortNote) : '',
          longNote: foundTimeSheet?.LongNote != undefined ? sqlUnsafe(foundTimeSheet.LongNote) : '',
          invoiceSubmitted: foundTimeSheet?.InvoiceSubmitted,
          invoiceId: foundTimeSheet?.InvoiceId || null,
          disableSubmit,
        })
      })
      .catch(err => {
        this.setState({ showSnackbar: true, snackbarMsg: 'There was an error loading data. Please Refresh.', snackbarSeverity: 'error' })
        console.error('will mount error', err)
      })
      .finally(() => this.setState({ fetching: false }))
  }

  getSelectedVendor(vendorIdd, vendors, foundTimeSheet) {
    const vendorId = (foundTimeSheet && foundTimeSheet.VendorIdd) || vendorIdd
    const vendor = vendors.find(v => v.VendorID === vendorId)
    return vendor ? { label: `${vendor.VendorName}`, value: vendor.VendorID } : { label: '', value: '' }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { data: { savedTimeSheets, selectedTimeSheetId }, setSelectedTimeSheet } = this.props
    const { fetching } = this.state

    this.checkQueryParams(selectedTimeSheetId, setSelectedTimeSheet)

    if (selectedTimeSheetId !== prevProps.data.selectedTimeSheetId) {
      const foundTimeSheet = savedTimeSheets.find(({ TimeSheetID }) => TimeSheetID === selectedTimeSheetId)
      if (!selectedTimeSheetId) {
        this.setRows({ Rows: [] })
      } else if (foundTimeSheet) {
        this.setRows(foundTimeSheet)
      } else if (!fetching) {
        this.setState({ showSnackbar: true, snackbarMsg: 'Could not find time sheet with that ID', snackbarSeverity: 'error' })
      }
    }
  }

  checkQueryParams(selectedTimeSheetId, setSelectedTimeSheet) {
    const queryParams = History.location.search
    const timeSheetId = queryParams.length ? parseInt(parseQuery(queryParams).id) || null : null
    if (selectedTimeSheetId !== timeSheetId) {
      setSelectedTimeSheet(timeSheetId)
    }
  }

  enterPressed(e) {
    if (e.keyCode === 13) { //Enter key
      const modifier = e.shiftKey ? -1 : 1
      const foundTrElement = this.recurseParentElements(document.activeElement)
      if (foundTrElement.tagName === 'TR') { //If current element has a table row as a parent
        const nextRowNum = parseInt(foundTrElement.id) + modifier
        if (nextRowNum !== 18 && nextRowNum !== -1) { //If current element is not on the last row
          if (this.state.rows[nextRowNum].ref) {
            this.state.rows[nextRowNum].ref.focus()
          }
        }
      } else {
        // this.state.rows[0].ref.focus();
      }
    }
  }

  recurseParentElements(element) {
    return element.tagName !== 'TR' && element.parentElement ? this.recurseParentElements(element.parentElement) : element
  }

  renderHeaderLabels() {
    return this.columns.map((col, idx) => {
      return (
        <TableCell style={{ padding: 5 }} key={'head' + idx.toString()}>
          {col.label}
        </TableCell>
      )
    })
  }

  renderTableRow(row, idx) {
    return (
      <TableRow
        classes={{ root: 'mui-row' }}
        id={idx.toString()}
        key={'row' + idx.toString()}
      >
        {this.renderTableCells(row, idx)}
      </TableRow>
    )
  }

  renderTableCells(row, idx) {
    const { data: { routeInfo } } = this.props
    const { errors, page, readOnly } = this.state
    const rowIdx = idx + (page * 18)
    return this.columns.map((col, id) => (
      <TableCell style={{ padding: 5, minWidth: col.field === 'routeId' ? 100 : 0 }} key={id.toString()}>
        <CellComponent
          {...{ row, col, idx, errors: errors[rowIdx], routeInfo, page, readOnly, canDelete: this.canDelete }}
          updateRowAndErrors={this.updateRowAndErrors(rowIdx)}
          clearRow={this.clearRow(rowIdx)}
          onRouteBlur={() => this.onRouteBlur(row, this.props.user, rowIdx)}
        />
      </TableCell>
    ))
  }

  updateRowAndErrors(idx) {
    return (row, errors) => {
      const rowsCopy = this.state.rows.slice()
      rowsCopy[idx] = row
      const errorsCopy = this.state.errors.slice()
      errorsCopy[idx] = errors
      this.setState({ rows: rowsCopy, errors: errorsCopy, changesSaved: false })
    }
  }

  getEmptyRows(idxs, rows) {
    const rowsCopy = rows.slice()
    idxs.forEach(idx => {
      const newRow = {}
      this.columns.forEach(({ field }) => {
        if (field === 'dateTimeStart' || field === 'dateTimeEnd') {
          newRow[field] = null
        } else if (field !== 'rowNum' && field !== 'clearRow') {
          newRow[field] = ''
        }
      })
      rowsCopy[idx] = newRow
    })
    return rowsCopy
  }

  clearRow(idx) {
    const { Jobs_ID } = this.state.rows[idx]
    return () => this.setState({
      rows: this.getEmptyRows([idx], this.state.rows),
      changesSaved: false,
      ...(Jobs_ID ? { deletedJobIDs: [...this.state.deletedJobIDs, Jobs_ID] } : {})
    })
  }

  onRouteBlur(row, user, rowIdx) {
    if (isValidInput(row, 'routeId')) {
      const { selectedVendor } = this.state
      const { user: { vendors } } = this.props
      const routeExtraData = row.extraData
      const routeVendorID = row.extraData.VendorIdd
      const userVendorID = selectedVendor.value === null || selectedVendor.value === void 0 ? user.vendorIdd : selectedVendor.value
      if (row.vendorOverride === void 0 && routeVendorID !== userVendorID) {
        const routeVendor = routeVendorID ? vendors.find(({ VendorID }) => VendorID === routeVendorID) : {
          VendorName: 'Unknown Vendor',
          VendorID: 0
        }
        this.setState({
          showModal: true,
          modalProperty: row.propNameAddress,
          routeVendor,
          routeExtraData,
          userVendorID,
          modalRowIdx: rowIdx
        })
      }
    }
  }

  setVendorOverride(idx) {
    return (vendorOverride, crewIdd) => {
      const { selectedVendor } = this.state
      const { user: { vendorIdd } } = this.props
      const userVendorID = selectedVendor.value === null || selectedVendor.value === void 0 ? vendorIdd : selectedVendor.value
      const { rows } = this.state
      const rowsCopy = rows.slice()
      const rowCopy = Object.assign({}, rows[idx])
      if (vendorOverride) {
        rowCopy.vendorOverride = userVendorID
        rowCopy.crewOverride = crewIdd
        rowsCopy[idx] = rowCopy
      } else {
        rowCopy.routeId = ''
        rowCopy.extraData = void 0
        rowCopy.propNameAddress = ''
        rowCopy.address = ''
        rowCopy.vendorOverride = void 0
        rowCopy.crewOverride = void 0
        rowsCopy[idx] = rowCopy
      }
      this.setState({ showModal: false, rows: rowsCopy })
      if (vendorOverride) {
        setTimeout(() => rowCopy.dateRef.focus(), 1)
      } else {
        setTimeout(() => rowCopy.ref.focus(), 1)
      }
    }
  }

  thereIsNoData(rows) {
    return !rows.filter(row => shouldValidate(row)).length
  }

  validateForm() {
    const { rows } = this.state

    if (this.thereIsNoData(rows)) return { thereIsNoData: true }

    const errors = rows.map(row => {
      const fieldsWithError = shouldValidate(row) ? validationFields.filter(f => !isValidInput(row, f)) : []
      return { fieldsWithError }
    })

    this.setState({ errors })

    return { errors }
  }

  onSubmit() {
    const { user, submitJob, data: { selectedTimeSheetId }, selectTimeSheet } = this.props
    const { selectedVendor: { value: selectedVendorId }, rows } = this.state
    const { errors, thereIsNoData } = this.validateForm()

    if (thereIsNoData) {
      this.setState({ showSnackbar: true, snackbarMsg: 'There is no data in the form', snackbarSeverity: 'error' })
    } else if (!errors.filter(({ fieldsWithError }) => fieldsWithError.length).length) {
      this.setState({ submitting: true, changesSaved: true })

      const deletedRows = this.state?.deletedJobIDs?.map(id => {
        return {
          Jobs_ID: id,
          deleted: true,
        }
      })

      const filteredMappedRows = rows.filter(r => r.routeId)
        .map(r => {
          if (!r.snowDepth) {
            r.snowDepth = 2;
          }
          return r;
        })

      const promises = [submitJob(user, selectedTimeSheetId, selectedVendorId, [...filteredMappedRows, ...deletedRows], this.state.longNote, this.state.shortNote)]

      Promise.all(promises)
        .then(() => {
          selectTimeSheet(null)
          const selectedVendor = this.getSelectedVendor(user.vendorIdd, user.vendors)
          this.setState({
            selectedVendor,
            showSnackbar: true,
            snackbarMsg: 'Time Sheet submitted successfully',
            snackbarSeverity: 'success',
            submitting: false,
            changesSaved: true,
            shortNote: '',
            longNote: ''
          })
        })
        .catch(err => {
          this.setState({
            showSnackbar: true,
            snackbarMsg: `There was an issue with the server: ${err}`,
            snackbarSeverity: 'error',
            submitting: false,
            changesSaved: false
          })
          console.error('onSubmit promises', err)
        })
    } else {
      this.setState({ showSnackbar: true, snackbarMsg: 'There is an error in the form', snackbarSeverity: 'error' })
    }
  }

  onPageChange(e, page) {
    this.setState({ page })
  }

  onAddPage() {
    const rowsCopy = this.state.rows.slice()
    const rows = rowsCopy.concat([...Array(18)].map(() => ({})))
    this.setState({ rows: this.getEmptyRows(range(rows.length - 18, rows.length), rows), page: (rows.length / 18) - 1 })
  }

  onSave() {
    const { rows } = this.state
    const { user, data: { selectedTimeSheetId }, saveTimeSheet } = this.props

    const mappedRows = rows.map(r => {
      if (r.dateTimeStart === 'Invalid date') {
        r.dateTimeStart = null
      }
      if (r.dateTimeEnd === 'Invalid date') {
        r.dateTimeEnd = null
      }
      return r
    })

    if (this.thereIsNoData(rows)) {
      this.setState({ showSnackbar: true, snackbarMsg: 'There is no data in the form', snackbarSeverity: 'error', })
    } else {
      this.setState({ saving: true })
      saveTimeSheet(user, selectedTimeSheetId, mappedRows, null, this.state.longNote, this.state.shortNote)
        .then(() => {
          this.setState({
            showSnackbar: true,
            snackbarMsg: 'Time Sheet saved successfully',
            snackbarSeverity: 'success',
            saving: false,
            changesSaved: true,
          })
        })
        .catch(err => {
          this.setState({ showSnackbar: true, snackbarMsg: `There was an issue with the server: ${err}`, saving: false, snackbarSeverity: 'error', })
          console.error('onSave', err)
        })
    }
  }

  renderVendorSelector() {
    const { selectedVendor } = this.state
    const { user } = this.props
    const { permissions, vendorIdd, vendorName } = user
    if (permissions.includes(OFFICE_USER)) {
      return (
        <div style={{ width: 400, display: 'flex', flexDirection: 'row' }}>
          <Typography style={{ marginTop: 15, marginRight: 20 }} variant="h4" color="primary">Vendor: </Typography>
          <SearchSelect
            label="Vendor"
            defaultOptions={this.vendorOptions.slice(0, 50)}
            value={selectedVendor}
            onChange={this.onVendorChange}
            loadOptions={this.filterVendors}
          />
        </div>
      )
    } else {
      return (
        <Typography variant="h4" color="primary">
          {vendorIdd ? `Vendor: ${vendorName} - ${vendorIdd}` : 'Unknown Vendor'}
        </Typography>
      )
    }
  }

  onVendorChange(option) {
    const { rows } = this.state
    const sheetHasRouteId = rows.find(({ routeId }) => routeId)
    if (sheetHasRouteId) {
      this.setState({ showVendorChangeModal: true })
    } else {
      const { value, label } = option || {}
      this.setState({ selectedVendor: { label, value } })
    }
  }

  filterVendors(search) {
    return Promise.resolve(this.vendorOptions.filter(({ label }) => label.toLowerCase().includes(search.toLowerCase())).slice(0, 50))
  }

  renderTotalHours() {
    const { page, rows } = this.state
    const { pageTotal, grandTotal } = this.getTotalHoursForPage(page, rows)
    const pageTotals = Object.keys(pageTotal).map((key, idx) => {
      return (
        <Typography key={idx} style={{ textAlign: 'right', width: 200, marginTop: 10, marginRight: 50 }}>
          {key}: {pageTotal[key].toFixed(2)}
        </Typography>
      )
    })
    const grandTotals = Object.keys(grandTotal).map((key, idx) => {
      return (
        <Typography key={idx} style={{ textAlign: 'right', width: 200, marginTop: 10, marginRight: 50 }}>
          {key} Total: {grandTotal[key].toFixed(2)}
        </Typography>
      )
    })
    return (
      <Paper>
        <Grid container direction="row" justify="flex-end">
          {pageTotals}
        </Grid>
        <Grid container direction="row" justify="flex-end">
          {grandTotals}
        </Grid>
      </Paper>
    )
  }

  getTotalHoursForPage(page, rows) {
    const startIdx = page * 18
    const endIdx = page * 18 + 18 - 1
    return rows.reduce((accum, { dateTimeStart, dateTimeEnd, plowsOrTechs, extraData }, idx) => {
      const hoursDiff = getHoursDiff(dateTimeStart, dateTimeEnd, plowsOrTechs) || 0
      if (hoursDiff) {
        const { grandTotal, pageTotal } = accum
        const { Prod_CrewDesc } = extraData || { Prod_CrewDesc: 'Uncategorized' }

        const addToGrandTotal = () => grandTotal[Prod_CrewDesc]
          ? grandTotal[Prod_CrewDesc] += hoursDiff
          : grandTotal[Prod_CrewDesc] = hoursDiff

        const addToPageTotal = () => pageTotal[Prod_CrewDesc]
          ? pageTotal[Prod_CrewDesc] += hoursDiff
          : pageTotal[Prod_CrewDesc] = hoursDiff

        if (idx >= startIdx && idx <= endIdx) { //page total
          addToPageTotal()
          addToGrandTotal()
        } else { //grand total
          addToGrandTotal()
          if (!pageTotal[Prod_CrewDesc]) pageTotal[Prod_CrewDesc] = 0
        }
      }
      return accum
    }, { grandTotal: {}, pageTotal: {} })
  }

  render() {
    const {
      rows,
      submitting,
      showSnackbar,
      snackbarSeverity,
      snackbarMsg,
      fetching,
      showModal,
      modalProperty,
      routeVendor,
      routeExtraData,
      page,
      modalRowIdx,
      saving,
      changesSaved,
      userVendorID,
      showVendorChangeModal,
      readOnly,
      longNote,
      shortNote,
      invoiceSubmitted,
      showLongNoteModal,
      showInvoiceModal,
      invoiceId,
      disableSubmit,
    } = this.state
    const { user, logout } = this.props
    const rowsPerPage = 18
    const start = page === 0 ? 0 : rowsPerPage * page
    const end = rowsPerPage * (page + 1)
    const slice = rows.slice(start, end)
    const tableRows = slice.map(this.renderTableRow)
    const selectedTimeSheetId = this?.props?.data?.selectedTimeSheetId

    return (
      <Grid>
        <Navigation
          logout={() => logout(user)}
          user={user}
          printPdf={() => generateTimesheetsPdf([
            {
              data: rows,
              vendor: this.state.selectedVendor.label,
              shortNote: this.state.shortNote,
              longNote: this.state.longNote,
              timesheetId: this.props.data.selectedTimeSheetId
            }
          ], user)}
          endImpersonation={this.props.endImpersonation}
        />
        {
          fetching ? (
            <div style={{ width: 50, margin: 'auto', marginTop: 150 }}><CircularProgress /></div>
          ) : (
            <div style={{ margin: 'auto', minWidth: 1463, marginTop: 85 }}>
              <div style={{ display: 'flex', gap: 10, justifyContent: 'space-between' }}>
                {this.renderVendorSelector()}
                <Input
                  placeholder='Note'
                  style={{ width: 300 }}
                  value={shortNote}
                  onChange={e => this.setState({ shortNote: e.target.value })}
                />
                <input type='file' id='file-input' hidden onChange={e => {
                  const file = e.target.files[0]
                  const filename = file?.name
                  const user = this.props.user
                  const timesheetId = this.props.data.selectedTimeSheetId
                  const read = new FileReader()

                  read.readAsBinaryString(file)

                  read.onloadend = () => {
                    emailInvoice(user, `Invoice ${user.username}${moment().format('MMDDYYhhmmss')}`, filename, btoa(read.result), timesheetId, user.vendorIdd).then(() => {
                      this.setState({
                        showSnackbar: true,
                        snackbarMsg: 'Invoice Submitted',
                        snackbarSeverity: 'success',
                        invoiceSubmitted: true,
                      })
                    })
                  }
                }}
                />
                {invoiceId && (
                  <Button
                    onClick={() => this.setState({
                      showInvoiceModal: true
                    })}
                  >
                    View Invoice
                  </Button>
                )}
                {invoiceSubmitted ? (
                  <>
                    <Button
                      onClick={() => this.setState({
                        showSnackbar: true,
                        snackbarMsg: 'Cannot submit invoice again -- Call Martz',
                        snackbarSeverity: 'error'
                      })}
                      disabled={!selectedTimeSheetId}
                    >
                      Create Invoice
                    </Button>
                    <Button
                      onClick={() => this.setState({
                        showSnackbar: true,
                        snackbarMsg: 'Cannot submit invoice again -- Call Martz',
                        snackbarSeverity: 'error'
                      })}
                    >
                      Attach Invoice
                    </Button>
                  </>
                ) : (
                  <>
                    <Button onClick={() => {
                      selectedTimeSheetId ?
                        this.setState({ showInvoiceModal: true }) :
                        this.setState({
                          showSnackbar: true,
                          snackbarMsg: 'Timesheet must be saved before submitting an invoice.',
                          snackbarSeverity: 'error'
                        })
                    }}>Create Invoice</Button>
                    <Button>
                      {selectedTimeSheetId ? (
                        <label style={{ cursor: 'pointer', height: 45, display: 'flex', alignItems: 'center' }} htmlFor='file-input'>
                          Attach Invoice
                        </label>
                      ) : (
                        <label onClick={() => (
                          this.setState({
                            showSnackbar: true,
                            snackbarMsg: 'Timesheet must be saved before submitting an invoice.',
                            snackbarSeverity: 'error'
                          })
                        )}>
                          Attach Invoice
                        </label>
                      )}
                    </Button>
                  </>
                )}

                <Button onClick={() => this.setState({ showLongNoteModal: true })}>Add Note</Button>
              </div>
              <Paper style={{ marginTop: 10 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      {this.renderHeaderLabels()}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {tableRows}
                  </TableBody>
                </Table>
              </Paper>

              {this.renderTotalHours()}

              <Paper style={{ height: 60, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                <TablePagination
                  style={{ marginTop: 5 }}
                  rowsPerPageOptions={[]}
                  component="div"
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  backIconButtonProps={{
                    'aria-label': 'previous page',
                  }}
                  nextIconButtonProps={{
                    'aria-label': 'next page',
                  }}
                  onChangePage={this.onPageChange}
                />

                <Button
                  style={{ margin: 10 }}
                  variant="contained"
                  size="small"
                  onClick={this.onAddPage}
                  disabled={readOnly}
                >
                  <Add />
                  Add Page
                </Button>


                {!this.submitted && (
                  <Button
                    style={{ margin: 10 }}
                    variant="contained"
                    size="small"
                    onClick={this.onSave}
                    disabled={submitting || saving || readOnly}
                  >
                    {
                      saving
                        ? <CircularProgress />
                        : (
                          <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <Save style={{ marginRight: 5 }} />
                            Save
                          </div>
                        )
                    }
                  </Button>
                )}
                <Button
                  style={{ margin: 10 }}
                  variant="contained"
                  size="large"
                  color="primary"
                  onClick={this.onSubmit}
                  disabled={submitting || saving || readOnly || (this.submitted && !this.isAdmin) || disableSubmit}
                >
                  {
                    submitting
                      ? <CircularProgress />
                      : 'Submit'
                  }
                </Button>
              </Paper>

              <Toast
                visible={showSnackbar}
                message={snackbarMsg}
                type={snackbarSeverity}
                onHiding={() => this.setState({ showSnackbar: false })}
                displayTime={4000}
              />

              <RouteChickenModal
                setVendorOverride={this.setVendorOverride(modalRowIdx)}
                showModal={showModal}
                modalProperty={modalProperty}
                routeExtraData={routeExtraData}
                routeVendor={routeVendor}
                userVendorID={userVendorID}
                crews={user.crews}
              />
              <VendorChangeModal
                showModal={showVendorChangeModal}
                hideModal={() => this.setState({ showVendorChangeModal: false })}
              />
              <LongNoteModal
                {...{
                  longNote,
                  setLongNote: (e) => this.setState({ longNote: e }),
                  showModal: showLongNoteModal,
                  hideModal: () => this.setState({ showLongNoteModal: false })
                }}
              />
              <InvoiceModal
                {...{
                  showModal: showInvoiceModal,
                  hideModal: () => this.setState({ showInvoiceModal: false }),
                  user: this.props.user,
                  timesheetId: this.props.data.selectedTimeSheetId,
                  setState: e => this.setState(e),
                  email: this.props.user.email,
                  invoiceId
                }}
              />
            </div>
          )
        }
        <Prompt
          when={!changesSaved && !saving}
          message="There are unsaved changes. Are you sure you want to leave?"
        />
      </Grid>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state, ...ownProps }
}

export default connect(mapStateToProps, actions)(TimeSheet)
